var exports = {
  "r": "selectable__2FiIAt",
  "A": "uninteractive__9T-Js3",
};

module.exports = exports;
